"use strict";

require("core-js/modules/es.date.to-string.js");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Subs = exports.Subscribe = void 0;
/**
 * Static functions for subscribing and unsubscribing to and from events.
 */

var Subscribe = /*#__PURE__*/function () {
  function Subscribe() {
    _classCallCheck(this, Subscribe);
  }

  _createClass(Subscribe, null, [{
    key: "subscribe",

    /**
     * Call a function that adds a listener and returns a function that will unsubscribe the listener.
     *
     * The function passed in will be called immediately to add the listener,
     * and its Unsubscribe function will be returned.
     *
     * @param subscribe The subscribe function, which returns an Unsubscribe. Will be called immediately.
     * @returns The Unsubscribe function for this subscription.
     */
    value: function subscribe(_subscribe) {
      try {
        return _subscribe();
      } catch (e) {
        console.error(e);
      }

      return function () {// No-op when catching an error
      };
    }
    /**
     * Subscribe to an emitter event. Returns a function that will unsubscribe the listener.
     *
     * @param eventEmitter The [EventEmitter](https://nodejs.org/api/events.html#class-eventemitter) to subscribe to.
     * @param eventName The name of the event to listen for.
     * @param listener The listener callback that is called when the event occurs.
     * @returns The Unsubscribe function for this subscription.
     */

  }, {
    key: "subscribeEvent",
    value: function subscribeEvent(eventEmitter, eventName, listener) {
      eventEmitter.addListener(eventName, listener);
      return function () {
        eventEmitter.removeListener(eventName, listener);
      };
    }
    /**
     * Appends an event listener for events whose type attribute value is type. The callback argument sets the callback
     * that will be invoked when the event is dispatched.
     *
     * The options argument sets listener-specific options. For compatibility this can be a boolean, in which case the
     * method behaves exactly as if the value was specified as options's capture.
     *
     * When set to true, options's capture prevents callback from being invoked when the event's eventPhase attribute
     * value is BUBBLING_PHASE. When false (or not present), callback will not be invoked when event's eventPhase attribute
     * value is CAPTURING_PHASE. Either way, callback will be invoked if event's eventPhase attribute value is AT_TARGET.
     *
     * Returns a function that will unsubscribe the listener.
     *
     * @param domObj The DOM object to subscribe to for events.
     * @param eventName The name of the event to listen for.
     * @param listener The listener callback that is called when the event occurs.
     * @param options Listener-specific options. See function description.
     * @returns The Unsubscribe function for this subscription.
     */

  }, {
    key: "subscribeDOMEvent",
    value: function subscribeDOMEvent(domObj, eventName, listener, options) {
      domObj.addEventListener(eventName, listener, options);
      return function () {
        domObj.removeEventListener(eventName, listener, options);
      };
    }
    /**
     * Sets a timer which executes a function once the timer expires using `setTimeout`.
     * Returns an unsubscribe function that clears the timeout using `clearTimeout`.
     *
     * @param handler A function to be executed after the timer expires.
     * @param delay The time, in milliseconds that the timer should wait before the specified function or code is executed. If this parameter is omitted, a value of 0 is used, meaning execute "immediately", or more accurately, the next event cycle.
     * @param args Additional arguments which are passed through to the handler specified.
     * @returns The Unsubscribe function for this subscription.
     */

  }, {
    key: "setTimeout",
    value: function (_setTimeout) {
      function setTimeout(_x, _x2) {
        return _setTimeout.apply(this, arguments);
      }

      setTimeout.toString = function () {
        return _setTimeout.toString();
      };

      return setTimeout;
    }(function (handler, delay) {
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      var timeout = setTimeout(handler, delay, args);
      return function () {
        return clearTimeout(timeout);
      };
    })
    /**
     * Repeatedly calls a function with a fixed time delay between each call using `setInterval`.
     * Returns an unsubscribe function that clears the interval using `clearInterval`.
     *
     * @param handler A function to be executed after the timer expires.
     * @param delay The time, in milliseconds (thousandths of a second), the timer should delay in between executions of the specified function or code. Defaults to 0 if not specified.
     * @param args Additional arguments which are passed through to the handler once the timer expires.
     * @returns The Unsubscribe function for this subscription.
     */

  }, {
    key: "setInterval",
    value: function (_setInterval) {
      function setInterval(_x3, _x4) {
        return _setInterval.apply(this, arguments);
      }

      setInterval.toString = function () {
        return _setInterval.toString();
      };

      return setInterval;
    }(function (handler, delay) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      var interval = setInterval(handler, delay, args);
      return function () {
        return clearInterval(interval);
      };
    })
    /**
     * Call all unsubscribe functions passed in. Can pass either an array of unsubscribe functions,
     * or a single unsubscribe function.
     *
     * @param unsubs An array of unsubscribe functions, or a single unsubscribe function.
     */

  }, {
    key: "unsubAll",
    value: function unsubAll(unsubs) {
      if (Array.isArray(unsubs)) {
        unsubs.forEach(function (unsub) {
          try {
            unsub();
          } catch (e) {
            console.error(e);
          }
        });
      } else {
        try {
          unsubs();
        } catch (e) {
          console.error(e);
        }
      }
    }
    /**
     * Creates and returns a cleanup function that, when called, calls all unsubscribe functions provided.
     *
     * @param unsubs All subscriptions to be unsubscribed when the returned cleanup function is called.
     * @returns A cleanup function that unsubscribes all subscriptions provided.
     */

  }, {
    key: "createCleanup",
    value: function createCleanup(unsubs) {
      return function () {
        return Subscribe.unsubAll(unsubs);
      };
    }
  }]);

  return Subscribe;
}();

exports.Subscribe = Subscribe;
/**
 * A Subs object can be used to subscribe and unsubscribe to events,
 * and to collect subscriptions in an array to be unsubscribed all at once.
 *
 * Calling any of the subscribe functions will add the unsubscribe function to
 * an internal array. You can then call `unsubAll()` to unsubscribe all
 * at once and clear the list.
 */

var Subs = /*#__PURE__*/function () {
  /**
   * Construct a new Subs object.
   *
   * A Subs object can be used to subscribe and unsubscribe to events,
   * and to collect subscriptions in an array to be unsubscribed all at once.
   *
   * Calling any of the subscribe functions will add the unsubscribe function to
   * an internal array. You can then call `unsubAll()` to unsubscribe all
   * at once and clear the list.
   *
   * You can optionally pass in an array of unsubscribe functions to start with.
   *
   * @param list Optional array of unsubscribe functions. Defaults to an empty list.
   */
  function Subs() {
    var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, Subs);

    this.list = list;
  }
  /**
   * Call a function that adds a listener and returns a function that will unsubscribe the listener.
   *
   * The function passed in will be called immediately to add the listener,
   * and its Unsubscribe function will be returned.
   *
   * The Unsubscribe function will be added to the internal list of unsubs. You can unsubscribe all by calling `unsubAll()`.
   *
   * @param subscribe The subscribe function, which returns an Unsubscribe. Will be called immediately.
   * @returns The Unsubscribe function for this subscription.
   */


  _createClass(Subs, [{
    key: "subscribe",
    value: function subscribe(_subscribe2) {
      var unsub = Subscribe.subscribe(_subscribe2);
      this.push(unsub);
      return unsub;
    }
    /**
     * Subscribe to an emitter event. Returns a function that will unsubscribe the listener.
     *
     * The Unsubscribe function will be added to the internal list of unsubs. You can unsubscribe all by calling `unsubAll()`.
     *
     * @param eventEmitter The [EventEmitter](https://nodejs.org/api/events.html#class-eventemitter) to subscribe to.
     * @param eventName The name of the event to listen for.
     * @param listener The listener callback that is called when the event occurs.
     * @returns The Unsubscribe function for this subscription.
     */

  }, {
    key: "subscribeEvent",
    value: function subscribeEvent(eventEmitter, eventName, listener) {
      var unsub = Subscribe.subscribeEvent(eventEmitter, eventName, listener);
      this.push(unsub);
      return unsub;
    }
    /**
     * Subscribe to an event on a DOM object (Window or Node). Returns a function that will unsubscribe the listener.
     *
     * The Unsubscribe function will be added to the internal list of unsubs. You can unsubscribe all by calling `unsubAll()`.
     *
     * @param domObj The DOM object to subscribe to for events.
     * @param eventName The name of the event to listen for.
     * @param listener The listener callback that is called when the event occurs.
     * @returns The Unsubscribe function for this subscription.
     */

  }, {
    key: "subscribeDOMEvent",
    value: function subscribeDOMEvent(domObj, eventName, listener) {
      var unsub = Subscribe.subscribeDOMEvent(domObj, eventName, listener);
      this.push(unsub);
      return unsub;
    }
    /**
     * Sets a timer which executes a function once the timer expires using `setTimeout`.
     * Returns an unsubscribe function that clears the timeout using `clearTimeout`.
     *
     * The Unsubscribe function will be added to the internal list of unsubs. You can unsubscribe all by calling `unsubAll()`.
     *
     * @param handler A function to be executed after the timer expires.
     * @param delay The time, in milliseconds that the timer should wait before the specified function or code is executed. If this parameter is omitted, a value of 0 is used, meaning execute "immediately", or more accurately, the next event cycle.
     * @param args Additional arguments which are passed through to the handler specified.
     * @returns The Unsubscribe function for this subscription.
     */

  }, {
    key: "setTimeout",
    value: function (_setTimeout2) {
      function setTimeout(_x5, _x6) {
        return _setTimeout2.apply(this, arguments);
      }

      setTimeout.toString = function () {
        return _setTimeout2.toString();
      };

      return setTimeout;
    }(function (handler, delay) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        args[_key3 - 2] = arguments[_key3];
      }

      var timeout = setTimeout(handler, delay, args);

      var unsub = function unsub() {
        return clearTimeout(timeout);
      };

      this.push(unsub);
      return unsub;
    })
    /**
     * Repeatedly calls a function with a fixed time delay between each call using `setInterval`.
     * Returns an unsubscribe function that clears the interval using `clearInterval`.
     *
     * The Unsubscribe function will be added to the internal list of unsubs. You can unsubscribe all by calling `unsubAll()`.
     *
     * @param handler A function to be executed after the timer expires.
     * @param delay The time, in milliseconds (thousandths of a second), the timer should delay in between executions of the specified function or code. Defaults to 0 if not specified.
     * @param args Additional arguments which are passed through to the handler once the timer expires.
     * @returns The Unsubscribe function for this subscription.
     */

  }, {
    key: "setInterval",
    value: function (_setInterval2) {
      function setInterval(_x7, _x8) {
        return _setInterval2.apply(this, arguments);
      }

      setInterval.toString = function () {
        return _setInterval2.toString();
      };

      return setInterval;
    }(function (handler, delay) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }

      var interval = setInterval(handler, delay, args);

      var unsub = function unsub() {
        return clearInterval(interval);
      };

      this.push(unsub);
      return unsub;
    })
    /**
     * Pushes an unsubscribe function onto the subscription list.
     *
     * You can unsubscribe all by calling `unsubAll()`.
     *
     * @param unsub The unsubscribe function to push to the subscription list.
     */

  }, {
    key: "push",
    value: function push(unsub) {
      this.list.push(unsub);
    }
    /**
     * Call all unsubscribe functions and clear the unsubscribe list.
     */

  }, {
    key: "unsubAll",
    value: function unsubAll() {
      Subscribe.unsubAll(this.list); // Empty the array, maintain the reference

      this.list.splice(0, this.list.length);
    }
    /**
     * Creates and returns a cleanup function that, when called, calls all unsubscribe functions and clears the unsubscribe list.
     *
     * @returns A cleanup function that unsubscribes all subscriptions and clears the unsubscribe list.
     */

  }, {
    key: "createCleanup",
    value: function createCleanup() {
      var _this = this;

      return function () {
        _this.unsubAll();
      };
    }
  }]);

  return Subs;
}();

exports.Subs = Subs;